import { render } from "./CampaignEdit.vue?vue&type=template&id=2b9fc5d0"
import script from "./CampaignEdit.vue?vue&type=script&lang=js"
export * from "./CampaignEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\devPrivate\\cmsDubaiMailing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__